import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { visibilityActions } from '../../store/actions/visibility';
import { authenticationActions } from '../../store/actions/authentication';
import ConnectServices from '../../providers/ConnectServices';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { Menu, Dropdown } from 'semantic-ui-react';
import * as Routes from '../../routes';

class NavigationBar extends Component {

  constructor (props) {
    super(props);
    this.FeathersService = props.services.feathers;
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS()
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => dispatch(push(path)),
      logOut: () => dispatch(authenticationActions.userAuthenticationLogout()),
      toggleNavigationSidebar: () => dispatch(visibilityActions.toggleNavigationSidebar())
    };
  }

  render () {
    const authentication = this.props.authentication || {};
    const user = authentication.user;
    const loading = authentication.loading;
    const {
      t,
      navigate,
      logOut,
      routing,
      toggleNavigationSidebar
    } = this.props;

    const signOut = () => {
      this.FeathersService.logout()
        .then(r => {
          logOut();
          navigate(Routes.SIGNIN);
        })
        .catch(e => {
          // console.error("issue logging out", e);
        });
    };

    if (routing.location.pathname.indexOf("print") != -1) {
      return null;
    }

    if (!!user && !!user.needsReset) {
      return null;
    }

    if (this.props.mobile) {
      return (
        <Menu style={{ borderRadius: 0, margin: 0 }}>
          <Menu.Item as={Link} to={Routes.ROOT}>
            C<strong>T</strong>C
          </Menu.Item>

          <Menu.Menu position="right">
            <Menu.Item icon="list layout" active={false} onClick={toggleNavigationSidebar} />
          </Menu.Menu>
        </Menu>
      );
    } else {
      return (
        <Menu stackable size="huge" style={{ borderRadius: 0, margin: 0 }}>
          <Menu.Item>
            <img src={require('../../assets/img/logo-ctc.png')} alt="Club Tennis Corrientes" />
          </Menu.Item>
          <Menu.Item as={Link} to={Routes.ROOT} header>Corrientes Tennis Club</Menu.Item>
          {
            !!loading ? '' : (
              !user ?
                <Menu.Menu position="right"><Menu.Item name="signin" as={Link} to={Routes.SIGNIN} content="Ingresar" active={false} icon="sign in" /></Menu.Menu> :
                <Menu.Menu position="right">
                  <Dropdown item text={(!!user && user.username) || "Loading..."}>
                    <Dropdown.Menu>
                      <Dropdown.Item icon="user" as={Link} to={Routes.PROFILE} text={t("navbar.profile")} />
                      <Dropdown.Item icon="sign out" text={t("navbar.signout")} onClick={signOut}/>
                    </Dropdown.Menu>
                  </Dropdown>
                </Menu.Menu>
            )
          }
        </Menu>
      );
    }
  }

}

NavigationBar.propTypes = {
  mobile: PropTypes.bool
};

NavigationBar.defaultProps = {
  mobile: false
};

const i18nEnhancement = translate('translations')(NavigationBar);
const withServices = ConnectServices(i18nEnhancement);

export default connect(NavigationBar.mapStateToProps, NavigationBar.mapDispatchToProps)(withServices);



// WEBPACK FOOTER //
// ./src/components/navigation/NavigationBar.jsx